<script>
  export let mobile;
  export let currentUser;
  export let group;
  export let sectionsShown;

  $: author = group && group.users[0];
</script>

<style style="text/scss" lang="scss">
  .no-recs-found {
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    margin-bottom: 60px;
    line-height: 23px;
    text-align: center;
    user-select: text;

    &.mobile {
      margin-top: 30px;
      box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.12);
    }

    &.desktop {
      padding: 20px;
      border: 2px solid rgb(236, 236, 236);
      margin: 60px auto 0px auto;
    }
  }
</style>

<div
  class="no-recs-found"
  class:mobile={mobile}
  class:desktop={!mobile}
  style={sectionsShown == 6 ? 'max-width: 1180px' : `max-width: ${196 * sectionsShown}px`}>
  {#if currentUser.copied_demo_user_id}
    Click the Add button below to add your first item to this list (e.g. make a list of travel recs, products you love,
    things to do, recipes.... anything!)
  {:else if group && group.permissions.contribute}
    {#if mobile}
      Click the Add button below to add your first item to this list (e.g. make a list of travel recs, products you
      love, things to do, recipes.... anything!)
    {:else}
      <div class="inner">
        <h3 style="font-weight: 600;">Click the “Add” button to add an item to this list</h3>
        <p style="font-size: 14px; opacity: 0.5">
          Make a list of travel recs, products you love, things to do, recipes... anything!
        </p>
      </div>
    {/if}
  {:else}
    Looks like {author && author.name} hasn’t added any items to this list just yet!
  {/if}
</div>
